import * as angular from "angular";
import * as Consts from "../ts/rlAdmin.consts";
import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";

import { AclService } from "../services/acl-service";
import { AdminService } from "../services/admin-service";
import { DocGenConfigService } from "../services/doc-gen-config-service";
import { EntityConfigService } from "../services/entity-config-service";
import { EntityService } from "../services/entity-service";
import { IdentityService } from "../services/identity-service";
import { NotifyService } from "../services/notify-service";
import { ReportService } from "../services/report-service";
import { SecurityConfigService } from "../services/security-config-service";
import { WorkflowConfigService } from "../services/workflow-config-service";

export class EditCharacteristicController {
	static $inject = ["$timeout", "$window", "entityConfigService", "notifyService"];

	public charTypeID: number = -1;
	public charID: number = -1;
	public lovs: Models.ICharacteristicMetaDataValue[] = [];
	public valueLabel: string = "";
	public defInd: number = 0;
	public editMode: { [key: number]: boolean } = {};
	public modalOpenState: boolean = false;
	public defOptions: { [key: number]: string } = { 1: "Yes", 0: "No" };

	constructor(private readonly $timeout: ng.ITimeoutService,
		private readonly $window: ng.IWindowService,
		private readonly entityConfigService: EntityConfigService,
		private readonly notifyService: NotifyService) {
	}

	Init(charTypeID: number, charID: number, openModel: number) {
		this.charTypeID = charTypeID;
		this.charID = charID;
		this.LoadList();
		if (openModel == 1) {
			this.$timeout(() => { this.OpenModal(); });
		}
	}

	LoadList() {
		return this.entityConfigService.getCharacteristicMetaDataValueList(this.charTypeID, this.charID)
			.then((result) => {
				this.lovs = result;
			});
	}

	AddNew() {
		this.notifyService.startProgress();
		this.entityConfigService.createCharacteristicMetaDataValue(this.charTypeID, this.charID, this.valueLabel, this.defInd)
			.then(() => {
				this.valueLabel = "";
				this.defInd = 0;
				return this.LoadList();
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Edit(lov: Models.ICharacteristicMetaDataValue) {
		this.editMode = {};
		this.editMode[lov.characteristicValueID] = true;
	}

	Update(lov: Models.ICharacteristicMetaDataValue) {
		this.notifyService.startProgress();
		this.entityConfigService.updateCharacteristicMetaDataValue(this.charTypeID, this.charID, lov.characteristicValueID, lov.characteristicValueLabel, lov.defaultIndicator, lov.sequenceNumber)
			.then(() => {
				this.editMode = {};
				return this.LoadList();
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Delete(lov: Models.ICharacteristicMetaDataValue) {
		if (this.$window.confirm("Are you sure you want to Delete this value?")) {
			this.notifyService.startProgress();
			this.entityConfigService.deleteCharacteristicMetaDataValue(this.charTypeID, this.charID, lov.characteristicValueID)
				.then(() => {
					this.editMode = {};
					return this.LoadList();
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	DeleteAll() {
		if (this.$window.confirm("Are you sure you want to Delete all User Defined Values?")) {
			this.notifyService.startProgress();
			this.entityConfigService.deleteAllCharacteristicMetaDataValue(this.charTypeID, this.charID)
				.then(() => {
					this.editMode = {};
					this.modalOpenState = false;
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	Cancel(lov: Models.ICharacteristicMetaDataValue) {
		this.editMode = {};
		this.LoadList();
	}

	OpenModal() {
		this.modalOpenState = true;
	}

	intKey(key: any) {
		return _.parseInt(key);
	}
}



export class CacheAdminController {
	static $inject = ["$scope", "adminService", "notifyService"];

	divID: string;
	charTypeID: string;
	recordID: string;
	templateID: string;
	clearPattern: string;
	mode: string;

	benchmarkDivID: number;
	benchmarkCharTypeID: number;
	benchmarkRecordCount: number;
	benchmarkResults: string;

	constructor(private $scope: ng.IScope, private adminService: AdminService, private notifyService: NotifyService) {

		this.divID = "*";
		this.templateID = "*";
		this.charTypeID = "*";
		this.recordID = "*";
		this.mode = "entity";

		this.benchmarkDivID = null;
		this.benchmarkCharTypeID = null;
		this.benchmarkRecordCount = 250;
		this.benchmarkResults = "";

		$scope.$watch(() => [this.divID, this.templateID, this.charTypeID, this.recordID, this.mode],
			(newValue, oldValue) => {

				var divVal = this.divID || "*";
				var charTypeVal = this.charTypeID || "*";
				var recVal = this.recordID || "*";
				var templateVal = this.templateID || "*";

				if (this.mode == "entity") {
					this.clearPattern = "d" + divVal + "c" + charTypeVal + "r" + recVal + ".*";
				} else if (this.mode == "template") {
					this.clearPattern = "d" + divVal + "c" + charTypeVal + "t" + templateVal + ".*";
				} else if (this.mode == "all") {
					this.clearPattern = "*";
				}
			}, true);
	}

	ClearCache() {
		this.notifyService.startProgress();
		this.adminService.refreshCache(this.clearPattern)
			.then(() => {
				this.notifyService.notifySuccess("Cache Cleared");
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Benchmark() {
		this.notifyService.startProgress();
		this.adminService.benchmarkCache(this.benchmarkDivID, this.benchmarkCharTypeID, this.benchmarkRecordCount)
			.then((result) => {
				this.benchmarkResults = result.results;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}
}

export class JobAdminController {
	static $inject = ["$scope", "$window", "adminService", "notifyService"];

	detailJob: Models.IJobState;
	jobs: Models.IJobState[];

	dailyDigestDivs: string;
	dailyDigestEmails: string;
	dailyDigestRoles: string;
	dailyDigestJobRecIDs: string;
	dailyDigestCatalogRecIDs: string;
	dailyDigestStartDate: Date;
	dailyDigestEndDate: Date;
	dailyDigestColumnsToExclude: string;
	dailyDigestStatusID: number;
	emailType: string;

	constructor(private $scope: ng.IScope, private $window: ng.IWindowService, private adminService: AdminService, private notifyService: NotifyService) {

		this.detailJob = null;
		this.jobs = [];

		this.dailyDigestDivs = "31";
		this.emailType = "1";
		this.dailyDigestColumnsToExclude = "Notes";
		this.dailyDigestStatusID = 3;

		this.RefreshJobs();
	}

	ShowDetails(job: Models.IJobState) {
		this.detailJob = job;
	}

	RefreshJobs() {
		this.notifyService.startProgress();
		this.adminService.getJobs()
			.then((results) => {
				this.jobs = results;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	DeleteJobInfo(job: Models.IJobState) {
		if (this.$window.confirm("Are you sure you want to delete this job info?")) {
			this.notifyService.startProgress();
			this.adminService.deleteJobInfo(job.jobID)
				.then(() => {
					this.notifyService.notifySuccess("Job Info Deleted");
					return this.RefreshJobs();
				},
					() => {
						this.notifyService.notifyError("Error Deleting Info");
					})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.notifyService.broadcastDone();
		}
	}

	CancelJob(job: Models.IJobState) {
		if (this.$window.confirm("Are you sure you want to cancel this job?")) {
			this.notifyService.startProgress();
			this.adminService.cancelJob(job.jobID)
				.then(() => {
					this.notifyService.notifySuccess("Job Cancelled");
				}, () => {
					this.notifyService.notifyError("Error cancelling Job");
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.notifyService.broadcastDone();
		}
	}

	RunAlertNotifications() {
		this.notifyService.startProgress();

		this.adminService.processAlertNotifications("{35bf6368-090e-44d2-a01d-53c26ff84296}")
			.then((results) => {
				this.notifyService.notifySuccess("Alert Notification Job Complete");
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	RunDailyDigest() {
		this.notifyService.startProgress();

		this.adminService.processDailyDigest("{f9dc74a8-77d3-48b3-a817-ae63be1e1b2c}", this.dailyDigestDivs, this.dailyDigestEmails, this.dailyDigestRoles, this.dailyDigestStartDate, this.dailyDigestEndDate, this.dailyDigestColumnsToExclude, this.dailyDigestStatusID, _.parseInt(this.emailType))
			.then((results) => {
				this.notifyService.notifySuccess("Daily Digest Job Complete");
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}
}



export class WorkflowNotificationConfigController {

	static $inject = ["$scope", "$window", "workflowConfigService", "notifyService", "docGenConfigService"];

	charTypeID: number;
	editMode: boolean;
	processes: Models.IWFProcess[];
	notifications: Models.IWFNotificationWithFlags[];           // list of processes based on charTypeID

	selectedProcess: Models.IWFProcess;
	selectedNotification: Models.IWFNotificationWithFlags;

	allDocTemplateTypes: Models.IWFDocumentTemplateType[];
	allDocTemplatesForCharType: Models.IDocTemplateConfig[];

	notificationList: { [key: number]: string }; // for validation

	processID: number; //from init, for navigational purposes

	constructor(private $scope: ng.IScope, private $window: ng.IWindowService, private workflowConfigService: WorkflowConfigService, private notifyService: NotifyService, private docGenConfigService: DocGenConfigService) {
		this.charTypeID = -1;
		this.editMode = false;
		this.processes = [];
		this.notifications = [];
		this.selectedNotification = <Models.IWFNotificationWithFlags>{};
		this.allDocTemplateTypes = [];
		this.notificationList = {};
		this.processID = 0;
		this.allDocTemplatesForCharType = [];

		this.$scope.$watch(() => this.selectedProcess, (newValue: Models.IWFProcess, oldValue: Models.IWFProcess) => {
			if (newValue != oldValue && newValue != null) {
				this.SetProcess(this.selectedProcess.processID);
			}
		}, true);


	}

	Init(processID: number) {
		this.processID = processID;
		this.LoadProcesses(this.charTypeID);
	}

	LoadDocTemplateTypes(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.docGenConfigService.getDocTemplatesByCharType(this.charTypeID)
			.then((result) => {
				this.allDocTemplatesForCharType = result;
			}).finally(() => {
				this.notifyService.endProgress();
			});
		//return this.workflowConfigService.getDocTemplateTypes()
		//    .then((result) => {
		//        this.allDocTemplateTypes = result;
		//    }).finally(() => {
		//        this.notifyService.endProgress();
		//    });
	}

	LoadProcesses(charTypeID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getProcesses(charTypeID)
			.then((result) => {
				this.processes = result;
				if (this.processID > 0) {
					this.selectedProcess = _.find(result, (p) => { return p.processID == this.processID; });
				}
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	SetProcess(processID: number) {
		if (!_.isNull(this.selectedProcess)) {
			this.charTypeID = this.selectedProcess.charTypeID;
			this.LoadNotifications(processID);
			this.LoadDocTemplateTypes();
		}
	}

	LoadNotifications(processID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getNotifications(processID)
			.then((result) => {
				this.notifications = [];
				_.each(result, r => {
					var n = <Models.IWFNotificationWithFlags>{};
					n.notification = r;
					n.previewBool = r.previewIndicator == 0 ? false : true;
					this.notifications.push(n);
				});
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	SetNotificationList() {
		this.notificationList = {};
		_.forEach(this.notifications, (n) => {
			if (this.selectedNotification.notification.id != n.notification.id) {
				this.notificationList[n.notification.id] = n.notification.label;
			}
		});
	}

	Cancel(form: ng.IFormController) {
		form.$setPristine();
		this.editMode = !this.editMode;
		this.notifyService.broadcastDone();
	}

	Edit(notification: Models.IWFNotificationWithFlags) {
		this.selectedNotification = angular.copy(notification);
		this.SetNotificationList();
		this.editMode = true;
		this.notifyService.broadcastDone();
	}

	Create(process: Models.IWFProcess) {
		this.selectedProcess = process;
		this.selectedNotification = <Models.IWFNotificationWithFlags>{};
		this.selectedNotification.notification = <Models.IWFRoleNotification>{};
		this.selectedNotification.notification.id = 0;
		this.selectedNotification.notification.sequenceNumber = 0;
		this.selectedNotification.notification.processID = process.processID;
		this.selectedNotification.notification.bodyHTML = "";
		this.SetNotificationList();
		this.editMode = true;
	}

	Save(form: ng.IFormController): ng.IPromise<any> {
		if (form.$valid) {
			this.notifyService.startProgress();
			var notification = <Models.IWFRoleNotification>{};
			notification = this.selectedNotification.notification;
			notification.previewIndicator = this.selectedNotification.previewBool == true ? 1 : 0;
			return this.workflowConfigService.saveNotification(notification)
				.then((result) => {
					return this.LoadNotifications(this.selectedProcess.processID)
						.then(() => {
							form.$setPristine();
							this.notifyService.broadcastDone();
							this.notifyService.notifySuccess("Notification saved successfully");
							this.editMode = false;
						});
				}).finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	Delete(notification: Models.IWFNotificationWithFlags) {
		this.notifyService.startProgress();
		if (this.$window.confirm("Are you sure you want to Delete this Notification?")) {
			return this.workflowConfigService.deleteNotification(notification.notification.id, notification.notification.processID)
				.then((result) => {
					return this.LoadNotifications(this.selectedProcess.processID)
						.then(() => {
							this.notifyService.broadcastDone();
							this.notifyService.notifySuccess("Notification deleted successfully");
						});
				}).finally(() => {
					this.notifyService.endProgress();
				});
		}
		else {
			this.notifyService.broadcastDone();
		}
	}

	UpdateSequenceNumber(notificationID: number, direction: boolean) {
		this.notifyService.startProgress();
		return this.workflowConfigService.updateWorkflowNotificationSequenceNumber(this.selectedProcess.processID, notificationID, direction)
			.then((result) => {
				return this.LoadNotifications(this.selectedProcess.processID)
					.then(() => {
						this.notifyService.broadcastDone();
						this.editMode = false;
						this.notifyService.notifySuccess("Workflow Notification Sequence Numbers updated successfully");
					});
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}
}

export class WorkflowProcessConfigController {

	static $inject = ["$scope", "$window", "workflowConfigService", "entityConfigService", "notifyService", "$q"];

	charTypeID: number;
	editMode: boolean;
	processes: Models.IWFProcessConfig[];           // list of processes based on charTypeID

	selectedProcess: Models.IWFProcessConfig;
	allCharTypes: Models.ICharacteristicType[];

	processList: { [key: number]: string };    //for validation

	constructor(private $scope: ng.IScope, private $window: ng.IWindowService, private workflowConfigService: WorkflowConfigService, private entityConfigService: EntityConfigService,
		private notifyService: NotifyService, private $q: ng.IQService) {
		this.charTypeID = -1;
		this.editMode = false;
		this.processes = [];
		this.selectedProcess = null;
		this.allCharTypes = [];
		this.processList = {};
	}

	Init() {
		this.notifyService.startProgress();
		this.$q.all([this.LoadProcesses(this.charTypeID), this.LoadCharTypes()])
			.then(() => {
				//
			})
			.finally(() => {
				this.notifyService.endProgress();
			});

	}

	LoadProcesses(charTypeID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getProcessesWithSteps(charTypeID)
			.then((result) => {
				this.processes = result;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadCharTypes(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.entityConfigService.getCharacteristicTypes()
			.then((result) => {
				this.allCharTypes = result;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	SetProcessList() {
		this.processList = {};
		_.forEach(this.processes, (p) => {
			if (this.selectedProcess.processID != p.processID) {
				this.processList[p.processID] = p.processName;
			}
		});
	}

	Cancel(form: ng.IFormController) {
		form.$setPristine();
		this.editMode = false;
		this.notifyService.broadcastDone();
	}

	Edit(process: Models.IWFProcessConfig) {
		this.selectedProcess = angular.copy(process);
		this.SetProcessList();
		this.editMode = true;
		this.notifyService.broadcastDone();
	}

	Create() {
		this.selectedProcess = <Models.IWFProcessConfig>{};
		this.selectedProcess.processID = 0;
		this.SetProcessList();
		this.editMode = true;
	}

	Save(form: ng.IFormController): ng.IPromise<any> {
		if (form.$valid) {
			this.notifyService.startProgress();
			return this.workflowConfigService.saveProcess(this.selectedProcess)
				.then((result) => {
					return this.LoadProcesses(this.charTypeID)
						.then(() => {
							this.notifyService.broadcastDone();
							form.$setPristine();
							this.editMode = false;
							this.notifyService.notifySuccess("Process saved successfully");
						});
				}).finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	Delete(processID: number) {
		this.notifyService.startProgress();
		if (this.$window.confirm("Are you sure you want to Delete this Process?")) {
			return this.workflowConfigService.getProcessTemplateCount(processID)
				.then((templateCount) => {
					if (templateCount.data > 0) {
						this.notifyService.broadcastDone();
						this.notifyService.notifyError("Process could not be deleted. There are templates currently referencing this process.");
					}
					else {
						return this.workflowConfigService.deleteProcess(processID)
							.then((result) => {
								return this.LoadProcesses(this.charTypeID)
									.then(() => {
										this.notifyService.broadcastDone();
										this.notifyService.notifySuccess("Process deleted successfully");
									});
							}, (error) => {
								this.notifyService.broadcastDone();
								this.notifyService.notifyError("There Process could not be deleted. Please try again.");
							});
					}

				}).finally(() => {
					this.notifyService.endProgress();
				});
		}
		else {
			this.notifyService.broadcastDone();
		}
	}

	UpdateSequenceNumber(processID: number, direction: boolean) {
		this.notifyService.startProgress();
		return this.workflowConfigService.updateWorkflowProcessSequenceNumber(processID, direction)
			.then((result) => {
				return this.LoadProcesses(this.charTypeID)
					.then(() => {
						this.notifyService.broadcastDone();
						this.editMode = false;
						this.notifyService.notifySuccess("Workflow Process Sequence Numbers updated successfully");
					});
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}
}

export class WorkflowStepConfigController {

	static $inject = ["$scope", "$window", "workflowConfigService", "notifyService", "$q", "entityService", "adminService"];

	charTypeID: number;
	editMode: boolean;
	processes: Models.IWFProcessConfig[];           // all processes based on charTypeID
	steps: Models.IWFStep[];

	allActions: Models.IWFAction[];
	allRoles: Models.IWFActionRole[];

	selectedProcess: Models.IWFProcessConfig;
	selectedStep: Models.IWFStep;
	originalStep: Models.IWFStep;

	selectedRoleIDs: number[];
	selectedActions: number[];

	roleLabels: { [key: number]: string };

	stepID: number;                         //from init
	stepList: { [key: number]: string };    //for validation

	activeIndicators: { [key: number]: string };
	activeIndicator: {};

	reIndexAffected: boolean;
	reIndexAffectedRecords: number;
	checkAllRoles: boolean;
	checkAllActions = false;

	constructor(private $scope: ng.IScope, private $window: ng.IWindowService, private workflowConfigService: WorkflowConfigService,
		private notifyService: NotifyService, private $q: ng.IQService, private entityService: EntityService, private adminService: AdminService) {
		this.charTypeID = -1;
		this.editMode = false;
		this.processes = [];
		this.steps = [];
		this.selectedProcess = null;
		this.selectedStep = <Models.IWFStep>{};
		this.originalStep = <Models.IWFStep>{};
		this.selectedRoleIDs = [];
		this.roleLabels = {};
		this.selectedActions = [];
		this.stepID = 0;
		this.stepList = {};
		this.activeIndicators = {};
		this.activeIndicator = {};

		this.reIndexAffected = false;
		this.reIndexAffectedRecords = 0;
		this.checkAllRoles = false;

		this.$scope.$watch(() => this.selectedRoleIDs, (newValue: number[], oldValue: number[]) => {
			if (newValue != oldValue && newValue != null) {
				_.forEach(this.selectedRoleIDs, roleID => {
					if (_.isEmpty(this.roleLabels[roleID])) {
						this.roleLabels[roleID] = angular.copy(this.selectedStep.stepName);
					}
				});
				this.checkAllRoles = this.selectedRoleIDs && this.selectedRoleIDs.length === this.allRoles.length;
			}
		}, true);

		this.$scope.$watch(() => this.selectedProcess, (newValue: Models.IWFProcessConfig, oldValue: Models.IWFProcessConfig) => {
			if (newValue != oldValue && newValue != null) {
				this.SetProcess(this.selectedProcess.processID);
			}
		}, true);

		this.$scope.$watch(() => this.reIndexAffectedRecords, (newValue: number, oldValue: number) => {
			if (newValue != oldValue && newValue > 0) {
				this.reIndexAffected = true;
			}
		}, true);

		this.$scope.$watch(() => this.steps, (newValue: Models.IWFStep[], oldValue: Models.IWFStep[]) => {
			if (newValue != oldValue) {
				if (this.stepID > 0) {
					if (!_.isEmpty(_.find(this.steps, s => s.stepID == this.stepID))) {
						this.Edit(_.find(this.steps, s => s.stepID == this.stepID));
					}
					this.stepID = 0;
				}
			}
		});

		this.$scope.$watch(() => this.checkAllRoles, (newValue, oldValue) => {
			if (newValue != oldValue && newValue != null) {
				if (newValue) {
					if (this.allRoles.length > 0) {
						this.selectedRoleIDs = _.map(this.allRoles, r => r.roleID);
					}
				}
				else {
					this.selectedRoleIDs = [];
				}
			}
		}, true);

		this.$scope.$watch(() => this.checkAllActions, (newValue, oldValue) => {
			if (newValue != oldValue && newValue != null && oldValue != null) {
				if (newValue) {
					if (this.allActions.length > 0) {
						this.selectedActions = _.map(this.allActions, r => r.actionID);
					}
				}
				else {
					this.selectedActions = [];
				}
			}
		}, true);

	}

	Init(processID: number, stepID: number) {
		this.notifyService.startProgress();
		if (stepID > 0) {
			this.stepID = stepID;
		}
		var promises = [];
		var promise1 = this.LoadProcesses(this.charTypeID, processID);
		promises.push(promise1);

		var promise2 = this.LoadRoles();
		promises.push(promise2);

		var promise3 = this.LoadActiveIndicators();
		promises.push(promise3);

		this.$q.all(promises)
			.then(() => {
				//
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadActiveIndicators(): ng.IPromise<any> {
		//possibly replace with service call later
		this.activeIndicators[0] = "InActive";
		this.activeIndicators[1] = "Active";
		return;
	}

	LoadProcesses(charTypeID: number, processID): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getProcessesWithSteps(charTypeID)
			.then((result) => {
				this.processes = result;
				if (processID > 0) {
					this.selectedProcess = _.find(result, (p) => { return p.processID == processID; });
				}
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	SetProcess(processID: number) {
		if (!_.isNull(this.selectedProcess)) {
			this.LoadSteps(processID);
		}
	}

	SetStepList() {
		this.stepList = {};
		_.forEach(this.steps, (s) => {
			if (this.selectedStep.stepID != s.stepID) {
				this.stepList[s.stepID] = s.stepName;
			}
		});
	}


	LoadSteps(processID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getSteps(processID)
			.then((result) => {
				this.steps = result;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadRoles(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getRoles()
			.then((result) => {
				this.allRoles = result;
				this.checkAllRoles = this.selectedRoleIDs && this.selectedRoleIDs.length === this.allRoles.length;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadActions(processID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getActions(processID)
			.then((result) => {
				this.allActions = result;
				this.checkAllActions = this.selectedActions && this.selectedActions.length === this.allActions.length;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadStepRoleAssoc(processID: number, stepID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getStepRoleAssoc(processID, stepID)
			.then((result) => {
				this.roleLabels = {};
				_.each(result, (s) => {
					this.roleLabels[s.roleID] = s.stepName;
				});

				this.selectedRoleIDs = _.map(result, s => s.roleID);
				this.checkAllRoles = this.selectedRoleIDs && this.selectedRoleIDs.length === this.allRoles.length;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	Edit(step: Models.IWFStep) {
		this.selectedStep = <Models.IWFStep>angular.copy(step);
		this.originalStep = <Models.IWFStep>angular.copy(step);
		this.activeIndicator = this.activeIndicators[this.selectedStep.activeIndicator];
		var promises = [];

		var promise1 = this.LoadActions(step.processID);
		promises.push(promise1);

		var promise2 = this.LoadStepRoleAssoc(step.processID, step.stepID);
		promises.push(promise2);

		var promise3 = this.LoadSelectedActions(step.processID, step.stepID);
		promises.push(promise3);

		this.$q.all(promises)
			.then(() => {
				this.SetStepList();
				this.notifyService.broadcastDone();
				this.editMode = true;
			});
	}

	LoadSelectedActions(processID: number, stepID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getAssociatedActions(processID, stepID)
			.then((result) => {
				this.selectedActions = _.map(result, r => r.actionID);
				this.checkAllActions = this.allActions && this.selectedActions.length === this.allActions.length;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	ResetStep() {
		this.selectedStep = <Models.IWFStep>{};
		this.selectedStep.stepID = 0;
		this.roleLabels = <{ [key: number]: string }>{};
		this.selectedRoleIDs = [];
		this.roleLabels = {};
		this.selectedActions = [];
		this.checkAllActions = false;
		this.checkAllRoles = false;
	}

	Cancel(form: ng.IFormController) {
		form.$setPristine();
		this.ResetStep();
		this.SetStepList();
		this.editMode = false;
		this.notifyService.broadcastDone();
	}

	Create(process: Models.IWFProcessConfig) {
		this.notifyService.startProgress();
		this.selectedProcess = process;
		this.ResetStep();
		return this.LoadActions(process.processID)
			.then(() => {
				this.SetStepList();
				this.activeIndicator = this.activeIndicators[1];
				if (this.allActions.length > 0) {
					this.selectedActions = _.map(this.allActions, r => r.actionID);
				}

				//this.checkAllActions = this.selectedActions && this.selectedActions.length === this.allActions.length;
				//if (this.allRoles.length > 0) {
				//    this.selectedRoleIDs = _.map(this.allRoles, r => r.roleID);
				//}
				this.editMode = true;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	Save(form: ng.IFormController): ng.IPromise<any> {
		if (form.$valid) {
			this.notifyService.startProgress();

			var step: Models.IWFStepSaveRequest = <Models.IWFStepSaveRequest>{};
			_.each(this.activeIndicators, (key, val) => {
				if (key == this.activeIndicator) {
					step.activeIndicator = parseInt(val);
				}
			});
			step.createdBy = this.selectedStep.createdBy;
			step.divID = this.selectedProcess.divisionID;
			step.lockIndicator = this.selectedStep.lockIndicator;
			step.deleteIndicator = this.selectedStep.deleteIndicator;
			step.processID = this.selectedProcess.processID;
			step.stepDescription = this.selectedStep.stepDescription;
			step.stepID = this.selectedStep.stepID;
			step.stepName = this.selectedStep.stepName;
			step.selectedActionIDs = this.selectedActions;
			step.stepRoleLabels = this.roleLabels;
			step.systemIndicator = this.selectedStep.systemIndicator;

			_.forEach(step.stepRoleLabels, (val: string, key) => {
				if (!_.any(this.selectedRoleIDs, (roleID) => {
					return roleID == _.parseInt(key);
				})) {
					delete step.stepRoleLabels[key];
				}
			});

			step.sequenceNumber = this.selectedStep.sequenceNumber;

			return this.workflowConfigService.saveStep(step)
				.then((result) => {
					return this.LoadSteps(this.selectedProcess.processID)
						.then(() => {
							form.$setPristine();
							this.notifyService.broadcastDone();
							this.notifyService.notifySuccess("Step configuration saved successfully");
							this.editMode = false;

							if (step.activeIndicator != this.originalStep.activeIndicator || step.deleteIndicator != this.originalStep.deleteIndicator || step.stepName != this.originalStep.stepName) {
								this.workflowConfigService.getAffectedEntitiesCount(step)
									.then((result) => {
										if (result.data > 0) {
											this.reIndexAffectedRecords = result.data;
											if (step.stepName != this.originalStep.stepName) {
												this.UpdateWFStepRelatedEntities(step);
											}
											if (step.stepName == this.originalStep.stepName && step.deleteIndicator != this.originalStep.deleteIndicator) {
												this.ClearCacheForDiv();
											}
											this.ReIndexAffectedRecords();
										}
									});
							}
						});

				}).finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	ReIndexAffectedRecords() {
		this.reIndexAffected = true;
	}

	UpdateWFStepRelatedEntities(stepRequest: Models.IWFStepSaveRequest) {
		this.workflowConfigService.updateWFStepRelatedEntities(stepRequest)
			.then(() => {
				this.notifyService.notifySuccess("Related entities updated successfully.");
				this.ClearCacheForDiv();
			});
	}
	ClearCacheForDiv() {
		this.notifyService.startProgress();
		this.adminService.clearCacheForDiv()
			.then(() => {
				this.notifyService.notifySuccess("Cache Cleared");
			})
			.finally(() => {
				this.notifyService.endProgress();
			});

	}

	Delete(step: Models.IWFStep) {
		this.notifyService.startProgress();
		if (this.$window.confirm("Are you sure you want to Delete this Status?")) {
			return this.workflowConfigService.deleteStep(step.processID, step.stepID)
				.then((result) => {
					if (result.data) {
						this.notifyService.notifySuccess("Step deleted successfully");
					}
					else {
						this.notifyService.notifyError("Could not Delete Status because there are existing Records with the Status: " + step.stepName);
					}
				}).finally(() => {
					this.notifyService.endProgress();
					return this.LoadSteps(this.selectedProcess.processID)
						.then(() => {
							this.notifyService.broadcastDone();
						});
				});
		}
		else {
			this.notifyService.broadcastDone();
		}
	}

	UpdateSequenceNumber(stepID: number, direction: boolean) {
		this.notifyService.startProgress();
		return this.workflowConfigService.updateWorkflowStepSequenceNumber(this.selectedProcess.processID, stepID, direction)
			.then((result) => {
				return this.LoadSteps(this.selectedProcess.processID)
					.then(() => {
						this.notifyService.broadcastDone();
						this.editMode = false;
						this.notifyService.notifySuccess("Workflow Step Sequence Numbers updated successfully");
					});
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}
}

export class WorkflowActionConfigController {

	static $inject = ["$scope", "$window", "workflowConfigService", "notifyService", "$q"];

	charTypeID: number;
	editMode: boolean;
	selectedProcess: Models.IWFProcessConfig;       // set when selecting process from dropdown
	selectedAction: Models.IWFActionConfig;         // set when selecting to edit from action list
	processes: Models.IWFProcessConfig[];           // all processes based on charTypeID
	processActions: Models.IWFActionConfig[];       // list of actions for selected processID --used in initial list
	paths: Models.IWFActionPathConfig[];            // all paths, loaded by Init
	notifications: Models.IWFRoleNotification[];    // notifications based on process, when process is selected
	page: number;
	pageCount: number;
	selectedRoleIDs: number[];
	selectedNotifyChildren: { [partyID: number]: boolean } = {};
	selectedNotification: { [partyID: number]: number } = {};

	actionID: number;   //from init
	actionList: { [key: number]: string };  //for validation
	allParties: Models.IParty[];
	checkAllRoles = false;

	extensionPaths: Models.IWFExtensionPath[];

	constructor(private $scope: ng.IScope, private $window: ng.IWindowService, private workflowConfigService: WorkflowConfigService, private notifyService: NotifyService, private $q: ng.IQService) {
		this.charTypeID = -1;
		this.editMode = false;
		this.selectedProcess = null;
		this.selectedAction = <Models.IWFActionConfig>{};
		this.selectedRoleIDs = [];
		this.processes = [];
		this.processActions = [];
		this.paths = [];
		this.notifications = [];
		this.page = 0;
		this.pageCount = 0;

		this.actionID = 0;
		this.actionList = {};

		this.allParties = [];
		this.extensionPaths = [];

		this.$scope.$watch(() => this.selectedProcess, (newValue: Models.IWFProcessConfig, oldValue: Models.IWFProcessConfig) => {
			if (newValue != oldValue && newValue != null) {
				this.SetProcess();
			}
		}, true);

		this.$scope.$watch(() => this.processActions, (newValue: Models.IWFActionConfig[], oldValue: Models.IWFActionConfig[]) => {
			if (newValue != oldValue) {
				if (this.actionID > 0) {
					if (!_.isEmpty(_.find(this.processActions, a => a.actionID == this.actionID))) {
						this.Edit(_.find(this.processActions, a => a.actionID == this.actionID));
					}
					this.actionID = 0;
				}
			}
		}, true);

		this.$scope.$watch(() => this.checkAllRoles, (newValue, oldValue) => {
			if (newValue != oldValue && newValue != null) {
				if (newValue) {
					if (this.selectedAction.allRoles.length > 0) {
						this.selectedRoleIDs = _.map(this.selectedAction.allRoles, r => r.roleID);
					}
				}
				else {
					this.selectedRoleIDs = [];
				}
			}
		}, true);
	}

	Init(processID: number, actionID: number) {
		this.actionID = actionID;
		this.notifyService.startProgress();

		this.$q.all([this.LoadProcesses(this.charTypeID, processID)])
			.then(() => {
				this.LoadParties();
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadProcesses(charTypeID: number, processID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getProcessesWithSteps(charTypeID)
			.then((result) => {
				this.processes = result;
				_.each(this.processes, p => {
					var noChange = <Models.IWFStepConfig>{};
					noChange.processID = processID;
					noChange.stepID = 0;
					noChange.stepName = "No Status Change";
					p.steps.unshift(noChange);
				});
				if (processID > 0) {
					this.selectedProcess = _.find(result, p => p.processID == processID);
				}
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadActions(processID: number, charTypeID: number): ng.IPromise<any> {
		if (!_.isNull(this.selectedProcess)) {
			this.notifyService.startProgress();
			return this.workflowConfigService.getActionConfigs(processID, charTypeID)
				.then((result) => {
					this.processActions = result;
				}).finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	LoadActionExtensions(processID: number, actionID: number): ng.IPromise<any> {
		return this.workflowConfigService.getWorkflowActionExtensions(processID, actionID)
			.then((results) => {
				this.extensionPaths = results.paths;
			});
	}

	SetProcess() {
		if (!_.isNull(this.selectedProcess)) {
			this.LoadActions(this.selectedProcess.processID, this.charTypeID);
			this.LoadNotifications(this.selectedProcess.processID);
		}
	}

	ResetAction() {
		this.selectedAction = <Models.IWFActionConfig>{};
		this.selectedAction.actionID = 0;
		this.selectedAction.selectedSteps = {};
		this.selectedAction.selectedRoleNotifications = {};
		this.selectedAction.selectedPartyNotifications = [];
		this.selectedNotifyChildren = {};
		this.selectedNotification = {};
	}

	Create(process: Models.IWFProcessConfig) {
		this.selectedRoleIDs = [];
		this.selectedProcess = process;
		this.SetProcess();
		this.ResetAction();
		var promises = [];
		var promise1 = this.LoadRoles();
		promises.push(promise1);

		var promise2 = this.LoadNotifications(this.selectedProcess.processID);
		promises.push(promise2);

		var promise3 = this.LoadParties();
		promises.push(promise3);

		this.$q.all(promises)
			.then(() => {
				this.SetActionList();
				this.editMode = true;

				if (this.selectedAction.allRoles.length > 0) {
					this.selectedRoleIDs = _.map(this.selectedAction.allRoles, r => r.roleID);
				}
				this.checkAllRoles = this.selectedRoleIDs && this.selectedRoleIDs.length === this.selectedAction.allRoles.length;
			});

		this.selectedAction.pointProcID = 0;
		this.selectedAction.nextPageID = 1;
		this.selectedAction.selectedProcessIDs = [];
		this.selectedAction.selectedProcessIDs.push(this.selectedProcess.processID);
		this.selectedAction.selectedNotificationRoleIDs = [];
		this.selectedAction.selectedNotificationPartyIDs = [];

	}

	Edit(action: Models.IWFActionConfig) {
		return this.LoadEditAction(action)
			.then(() => {
				this.LoadPartyNotifications(action.actionID, action.processID)
					.then(() => {
						this.editMode = !this.editMode;
						this.notifyService.broadcastDone();
						this.LoadActionExtensions(action.processID, action.actionID);
					});
			});
	}

	Cancel(form: ng.IFormController) {
		this.checkAllRoles = false;
		this.LoadActions(this.selectedProcess.processID, this.charTypeID)
			.then(() => {
				form.$setPristine();
				this.editMode = false;
			}).finally(() => {
				this.notifyService.broadcastDone();
			});
	}

	SetActionList() {
		this.actionList = {};
		_.forEach(this.processActions, (p) => {
			if (this.selectedAction.actionID != p.actionID) {
				this.actionList[p.actionID] = p.actionName;
			}
		});
	}

	LoadEditAction(action: Models.IWFActionConfig): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getEditAction(action.processID, action.actionID, this.charTypeID)
			.then((result) => {
				this.selectedAction = result;
				this.selectedRoleIDs = _.map(result.selectedRoles, s => s.roleID);
				this.selectedAction.docIndicator = this.selectedAction.docGenIndicator;
				this.selectedAction.selectedPath = _.find(this.paths, x => x.actionPathID == action.pathID);
				this.SetActionList();
			}, () => {
				this.notifyService.notifyError("An error has occurred with fetching the Action");
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadPartyNotifications(actionID: number, processID: number): ng.IPromise<any> {
		return this.workflowConfigService.getPartiesWithNotifications(processID, actionID)
			.then((result) => {
				this.selectedAction.selectedNotificationPartyIDs = [];
				this.selectedAction.selectedPartyNotifications = [];
				this.selectedNotifyChildren = {};
				this.selectedNotification = {};
				_.each(result, (item, idx) => {
					this.selectedAction.selectedPartyNotifications.push({
						partyID: item.partyID,
						notificationID: item.messageID,
						notifyChildren: item.notifyChildren
					});
					this.selectedAction.selectedNotificationPartyIDs.push(item.partyID);
					this.selectedNotifyChildren[item.partyID] = item.notifyChildren;
					this.selectedNotification[item.partyID] = item.messageID;
				});
			});
	}

	LoadNotifications(processID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getNotifications(processID)
			.then((result) => {
				this.notifications = result;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadRoles(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getRoles()
			.then((result) => {
				this.selectedAction.allRoles = result;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadParties(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getParties()
			.then((result) => {
				this.allParties = result;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	GetProcessName(processID) {
		processID = Number(processID);
		var p = _.find(this.processes, (process) => process.processID === processID);
		return p ? p.processName : '';
	}

	Save(form: ng.IFormController): ng.IPromise<any> {
		if (form.$valid) {
			this.notifyService.startProgress();
			var aReq: Models.IWFActionSaveRequest = <Models.IWFActionSaveRequest>{};
			aReq.actionDescription = this.selectedAction.actionDescription;
			aReq.actionID = this.selectedAction.actionID;
			aReq.actionName = this.selectedAction.actionName;
			aReq.divisionID = this.selectedProcess.divisionID;
			aReq.nextPageID = this.selectedAction.nextPageID;
			aReq.processID = this.selectedProcess.processID;
			aReq.pointProcID = this.selectedAction.pointProcID;
			aReq.selectedNotificationIDs = {};
			aReq.selectedPartyNotifications = [];
			aReq.selectedStepIDs = {};
			aReq.selectedChainedActionIDs = {};
			aReq.sequenceNumber = this.selectedAction.sequenceNumber;
			aReq.docGenIndicator = this.selectedAction.docIndicator;

			for (var roleID in this.selectedAction.selectedRoleNotifications) {
				aReq.selectedNotificationIDs[roleID] = this.selectedAction.selectedRoleNotifications[roleID].id;
			}

			for (var processID in this.selectedAction.selectedSteps) {
				aReq.selectedStepIDs[processID] = this.selectedAction.selectedSteps[processID];
			}

			for (var processID in this.selectedAction.selectedChainedActions) {
				aReq.selectedChainedActionIDs[processID] = this.selectedAction.selectedChainedActions[processID];
			}

			aReq.selectedPartyNotifications = this.selectedAction.selectedPartyNotifications;

			aReq.selectedRoleIDs = this.selectedRoleIDs;

			aReq.selectedPartyIDs = _(this.selectedAction.selectedParties)
				.filter((p) => p != null)
				.map((p) => p.partyID)
				.valueOf();

			if (aReq.pointProcID == Consts.PointOfProcess.initialAction) {
				var prcActWithInitialAction = _.find(this.processActions, (pa) => {
					return pa.pointProcID == Consts.PointOfProcess.initialAction;
				});

				if (prcActWithInitialAction != null && prcActWithInitialAction.actionID != aReq.actionID) {
					if (this.$window.confirm("If another action is set to the Initial Action, saving will overwrite and set the current action to the Initial Action.")) {
						//Update this Process Action with pointProcessID set to Middle Action and then save current action
						this.workflowConfigService.getEditAction(prcActWithInitialAction.processID, prcActWithInitialAction.actionID, this.charTypeID)
							.then((result) => {
								prcActWithInitialAction = result;
								prcActWithInitialAction.pointProcID = Consts.PointOfProcess.middleAction;
								var prcActWithInitialActReq = this.MapPrcActionToWFActionSaveRequest(prcActWithInitialAction);
								this.workflowConfigService.saveAction(prcActWithInitialActReq)
									.then((result) => {
										return this.SaveAction(form, aReq);
									})
							});
					}
				}
				else {
					return this.SaveAction(form, aReq);
				}
			}
			else {
				return this.SaveAction(form, aReq);
			}
		}
	}

	SaveAction(form: ng.IFormController, aReq: Models.IWFActionSaveRequest): ng.IPromise<any> {
		return this.workflowConfigService.saveAction(aReq)
			.then((result) => {
				return this.LoadActions(this.selectedProcess.processID, this.charTypeID)
					.then(() => {
						form.$setPristine();
						this.notifyService.broadcastDone();
						this.notifyService.notifySuccess("Action saved successfully");
						this.editMode = false;
					});
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	CheckNotificationParty(partyID: number) {
		if (this.selectedAction.selectedPartyNotifications.find(x => x.partyID == partyID)) {
			_.remove(this.selectedAction.selectedPartyNotifications, (x) => x.partyID == partyID);
			delete this.selectedNotifyChildren[partyID];
			delete this.selectedNotification[partyID];
		}
		else {
			this.selectedAction.selectedPartyNotifications.push({
				partyID: partyID,
				notifyChildren: false,
				notificationID: undefined
			})
		}
	}

	CheckNotification(partyID: number) {
		var notif = this.selectedAction.selectedPartyNotifications.find(x => x.partyID == partyID);
		if (notif) {
			notif.notificationID = this.selectedNotification[partyID];
		}
	}

	CheckNotificationChildren(partyID: number, notifyChildren: boolean) {
		var notif = this.selectedAction.selectedPartyNotifications.find(x => x.partyID == partyID);
		if (notif) {
			notif.notifyChildren = notifyChildren;
			notif.notificationID = this.selectedNotification[partyID]
		}
	}

	CheckNotificationRole(roleID: number) {
		this.selectedAction.selectedRoleNotifications[roleID] = <Models.IWFRoleNotification>{};
	}

	CheckStepProcess(processID: number) {
		this.selectedAction.selectedChainedActions[processID] = undefined;
	}

	Delete(action: Models.IWFActionConfig) {
		this.notifyService.startProgress();
		if (this.$window.confirm("Are you sure you want to Delete this Action?")) {
			return this.workflowConfigService.deleteAction(action.processID, action.actionID)
				.then((result) => {
					return this.LoadActions(this.selectedProcess.processID, this.charTypeID)
						.then(() => {
							this.notifyService.broadcastDone();
							this.notifyService.notifySuccess("Action deleted successfully");
						});
				}).finally(() => {
					this.notifyService.endProgress();
				});
		}
		else {
			this.notifyService.broadcastDone();
		}
	}

	UpdateSequenceNumber(actionID: number, direction: boolean) {
		this.notifyService.startProgress();
		return this.workflowConfigService.updateWorkflowActionSequenceNumber(this.selectedProcess.processID, actionID, direction)
			.then((result) => {
				return this.LoadActions(this.selectedProcess.processID, this.charTypeID)
					.then(() => {
						this.notifyService.broadcastDone();
						this.editMode = false;
						this.notifyService.notifySuccess("Workflow Action Sequence Numbers updated successfully");
					});
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	MapPrcActionToWFActionSaveRequest(prcAction: Models.IWFActionConfig) {
		var aReq: Models.IWFActionSaveRequest = <Models.IWFActionSaveRequest>{};
		aReq.actionDescription = prcAction.actionDescription;
		aReq.actionID = prcAction.actionID;
		aReq.actionName = prcAction.actionName;
		aReq.divisionID = prcAction.divisionID;
		aReq.nextPageID = prcAction.nextPageID;
		aReq.processID = prcAction.processID;
		aReq.pointProcID = prcAction.pointProcID;
		aReq.selectedNotificationIDs = {};
		aReq.selectedPartyNotifications = [];
		aReq.selectedStepIDs = {};
		aReq.selectedChainedActionIDs = {};
		aReq.sequenceNumber = prcAction.sequenceNumber;
		aReq.docGenIndicator = prcAction.docIndicator;

		for (var roleID in prcAction.selectedRoleNotifications) {
			aReq.selectedNotificationIDs[roleID] = prcAction.selectedRoleNotifications[roleID].id;
		}

		for (var processID in prcAction.selectedSteps) {
			aReq.selectedStepIDs[processID] = prcAction.selectedSteps[processID];
		}

		for (var processID in prcAction.selectedChainedActions) {
			aReq.selectedChainedActionIDs[processID] = prcAction.selectedChainedActions[processID];
		}

		aReq.selectedPartyNotifications = prcAction.selectedPartyNotifications;

		aReq.selectedRoleIDs = _.map(prcAction.selectedRoles, s => s.roleID);

		aReq.selectedPartyIDs = _(prcAction.selectedParties)
			.filter((p) => p != null)
			.map((p) => p.partyID)
			.valueOf();

		return aReq;
	}
}

export class SecurityRoleConfigController {

	static $inject = ["$scope", "$window", "securityConfigService", "workflowConfigService", "notifyService"];

	initialized: boolean;
	editMode: boolean;
	roles: Models.IWFActionRole[];           // list of roles

	selectedRole: Models.IWFActionRole;

	rolesList: { [key: number]: string };

	constructor(private $scope: ng.IScope, private $window: ng.IWindowService,
		private securityConfigService: SecurityConfigService, private workflowConfigService: WorkflowConfigService,
		private notifyService: NotifyService) {
		this.initialized = false;
		this.editMode = false;
		this.roles = [];
		this.selectedRole = null;
		this.rolesList = {};


	}

	Init() {
		this.LoadRoles()
			.then(() => {
				this.initialized = true;
			});
	}

	LoadRoles(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getRoles()
			.then((result) => {
				this.roles = result;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	SetRolesList() {
		this.rolesList = {};
		_.forEach(this.roles, r => {
			if (this.selectedRole.roleID != r.roleID) {
				this.rolesList[r.roleID] = r.roleName;
			}
		});
	}

	Cancel(form: ng.IFormController) {
		form.$setPristine();
		this.editMode = false;
		this.notifyService.broadcastDone();
	}

	Edit(role: Models.IWFActionRole) {
		this.selectedRole = angular.copy(role);
		this.SetRolesList();
		this.editMode = true;
		this.notifyService.broadcastDone();
	}

	Create() {
		this.selectedRole = <Models.IWFActionRole>{};
		this.selectedRole.roleID = 0;
		this.editMode = true;
	}

	Save(form: ng.IFormController): ng.IPromise<any> {
		if (form.$valid) {
			this.notifyService.startProgress();
			return this.securityConfigService.saveRole(this.selectedRole)
				.then((result) => {
					return this.LoadRoles()
						.then(() => {
							this.notifyService.broadcastDone();
							form.$setPristine();
							this.editMode = false;
							this.notifyService.notifySuccess("Role saved successfully");
						});
				}).finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	Delete(roleID: number) {
		this.notifyService.startProgress();
		if (this.$window.confirm("Are you sure you want to Delete this Role?")) {
			return this.securityConfigService.deleteRole(roleID)
				.then((result) => {
					return this.LoadRoles()
						.then(() => {
							this.notifyService.broadcastDone();
							this.notifyService.notifySuccess("Role deleted successfully");
						});
				}).finally(() => {
					this.notifyService.endProgress();
				});
		}
		else {
			this.notifyService.broadcastDone();
		}
	}

	UpdateSequenceNumber(roleID: number, direction: boolean) {
		this.notifyService.startProgress();
		return this.securityConfigService.updateSequenceNumber(roleID, direction)
			.then((result) => {
				return this.LoadRoles()
					.then(() => {
						this.notifyService.broadcastDone();
						this.editMode = false;
						this.notifyService.notifySuccess("Role Sequence Numbers updated successfully");
					});
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}
}

export class SecurityStepConfigController {

	static $inject = ["$scope", "$window", "securityConfigService", "workflowConfigService", "notifyService", "$q"];

	initialized: boolean;
	charTypeID: number;
	roles: Models.IWFActionRole[];           // list of roles
	processes: Models.IWFProcess[];         // list of processes

	selectedRole: Models.IWFActionRole;
	selectedProcess: Models.IWFProcess;

	allSteps: Models.IWFStep[];

	selectedStepIDs: number[];
	selectedStepLabels: { [key: number]: string };

	roleID: number;       //from init for navigation

	constructor(private $scope: ng.IScope, private $window: ng.IWindowService,
		private securityConfigService: SecurityConfigService, private workflowConfigService: WorkflowConfigService,
		private notifyService: NotifyService, private $q: ng.IQService) {
		this.initialized = false;
		this.charTypeID = -1;
		this.roles = [];
		this.processes = [];

		this.selectedRole = null;
		this.selectedProcess = null;

		this.allSteps = [];

		this.selectedStepIDs = [];
		this.selectedStepLabels = {};
		this.roleID = 0;

		this.$scope.$watch(() => this.roles, (newValue: Models.IWFActionRole[], oldValue: Models.IWFActionRole[]) => {
			if (newValue != oldValue && newValue != null) {
				if (this.roleID > 0) {
					this.selectedRole = _.find(this.roles, r => { return r.roleID == this.roleID; });
					this.roleID = 0;
				}
			}
		}, true);

		this.$scope.$watch(() => this.selectedProcess, (newValue: Models.IWFProcess, oldValue: Models.IWFProcess) => {
			if (newValue != oldValue && newValue != null) {
				this.LoadSteps(this.selectedProcess.processID);
				if (!_.isNull(this.selectedRole)) {
					this.LoadStepLabels(this.selectedProcess.processID, this.selectedRole.roleID);
				}
			}
		}, true);

		this.$scope.$watch(() => this.selectedRole, (newValue: Models.IWFActionRole, oldValue: Models.IWFActionRole) => {
			if (newValue != oldValue && newValue != null) {
				if (!_.isNull(this.selectedProcess)) {
					this.LoadStepLabels(this.selectedProcess.processID, this.selectedRole.roleID);
				}
			}
		}, true);

		this.$scope.$watch(() => this.selectedStepIDs, (newValue: number[], oldValue: number[]) => {
			if (newValue != oldValue && newValue != null) {
				_.forEach(this.selectedStepIDs, stepID => {
					if (_.isEmpty(this.selectedStepLabels[stepID])) {
						var step = _.find(this.allSteps, step => step.stepID == stepID);
						this.selectedStepLabels[stepID] = step.stepName;
					}
				});
			}
		}, true);
	}

	Init(roleID: number) {
		this.roleID = roleID;
		this.$q.all([this.LoadRoles(), this.LoadProcesses(this.charTypeID)])
			.then(() => {
				this.initialized = true;
			});
	}

	LoadRoles(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getRoles()
			.then((result) => {
				this.roles = result;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadProcesses(charTypeID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getProcesses(charTypeID)
			.then((result) => {
				this.processes = result;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadSteps(processID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getSteps(processID)
			.then((result) => {
				this.allSteps = result;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadStepLabels(processID: number, roleID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getRoleStepAssoc(processID, roleID)
			.then((result) => {
				this.selectedStepLabels = {};
				_.each(result, (s) => {
					this.selectedStepLabels[s.stepID] = s.stepName;
				});
				this.selectedStepIDs = _.map(result, (s) => s.stepID);

			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	Cancel(form: ng.IFormController) {

		form.$setPristine();
		this.notifyService.broadcastDone();
	}

	Edit(role: Models.IWFActionRole) {
		this.selectedRole = angular.copy(role);
		this.notifyService.broadcastDone();
	}

	Create() {
		this.selectedRole = <Models.IWFActionRole>{};
		this.selectedRole.roleID = 0;
	}

	Save(form: ng.IFormController): ng.IPromise<any> {
		if (form.$valid) {
			this.notifyService.startProgress();
			var associations: Models.IWFStepRoleAssoc[] = [];
			_.forEach(this.selectedStepLabels, (val: string, key) => {
				if (_.any(this.selectedStepIDs, s => { return s == _.parseInt(key); })) {
					var assoc = <Models.IWFStepRoleAssoc>{};
					assoc.divisionID = this.selectedProcess.divisionID;
					assoc.processID = this.selectedProcess.processID;
					assoc.stepID = _.parseInt(key);
					assoc.stepName = val;
					assoc.roleID = this.selectedRole.roleID;
					associations.push(assoc);
				}
			});

			var request = <Models.IWFStepRoleAssocRequest>{};
			request.associations = associations;
			request.processID = this.selectedProcess.processID;
			request.roleID = this.selectedRole.roleID;

			return this.workflowConfigService.saveStepPermissions(request)
				.then((result) => {
					this.notifyService.broadcastDone();
					form.$setPristine();
					this.notifyService.notifySuccess("Step Permissions saved successfully");
				}).finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

}

export class SecurityActionConfigController {

	static $inject = ["$scope", "$window", "securityConfigService", "workflowConfigService", "notifyService", "$q"];

	initialized: boolean;
	charTypeID: number;
	roles: Models.IWFActionRole[];           // list of roles
	processes: Models.IWFProcess[];         // list of processes

	selectedRole: Models.IWFActionRole;
	selectedProcess: Models.IWFProcess;

	allActions: Models.IWFAction[];

	selectedActionIDs: number[];

	roleID: number;             //from init, for navigation

	constructor(private $scope: ng.IScope, private $window: ng.IWindowService,
		private securityConfigService: SecurityConfigService, private workflowConfigService: WorkflowConfigService,
		private notifyService: NotifyService, private $q: ng.IQService) {
		this.initialized = false;
		this.charTypeID = -1;
		this.roles = [];
		this.processes = [];

		this.selectedRole = null;
		this.selectedProcess = null;

		this.allActions = [];

		this.selectedActionIDs = [];
		this.roleID = 0;

		this.$scope.$watch(() => this.roles, (newValue: Models.IWFActionRole[], oldValue: Models.IWFActionRole[]) => {
			if (newValue != oldValue && newValue != null) {
				if (this.roleID > 0) {
					this.selectedRole = _.find(this.roles, r => { return r.roleID == this.roleID; });
					this.roleID = 0;
				}
			}
		}, true);

		this.$scope.$watch(() => this.selectedProcess, (newValue: Models.IWFProcess, oldValue: Models.IWFProcess) => {
			if (newValue != oldValue && newValue != null) {
				this.LoadActions(this.selectedProcess.processID);
				if (!_.isNull(this.selectedRole)) {
					this.LoadRoleActions(this.selectedProcess.processID, this.selectedRole.roleID);
				}
			}
		}, true);

		this.$scope.$watch(() => this.selectedRole, (newValue: Models.IWFActionRole, oldValue: Models.IWFActionRole) => {
			if (newValue != oldValue && newValue != null) {
				if (!_.isNull(this.selectedProcess)) {
					this.LoadRoleActions(this.selectedProcess.processID, this.selectedRole.roleID);
				}
			}
		}, true);

	}

	Init(roleID: number) {
		this.roleID = roleID;

		this.$q.all([this.LoadRoles(), this.LoadProcesses(this.charTypeID)])
			.then(() => {
				this.initialized = true;
			});
	}

	LoadRoles(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getRoles()
			.then((result) => {
				this.roles = result;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadProcesses(charTypeID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getProcesses(charTypeID)
			.then((result) => {
				this.processes = result;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadActions(processID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getActions(processID)
			.then((result) => {
				this.allActions = result;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadRoleActions(processID: number, roleID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getRoleActions(processID, roleID)
			.then((result) => {
				this.selectedActionIDs = [];
				this.selectedActionIDs = _.map(result, s => s.actionID);
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}


	Cancel(form: ng.IFormController) {

		form.$setPristine();
		this.notifyService.broadcastDone();
	}

	Edit(role: Models.IWFActionRole) {
		this.selectedRole = angular.copy(role);
		this.notifyService.broadcastDone();
	}

	Create() {
		this.selectedRole = <Models.IWFActionRole>{};
		this.selectedRole.roleID = 0;
	}

	Save(form: ng.IFormController): ng.IPromise<any> {
		if (form.$valid) {
			this.notifyService.startProgress();
			var associations: Models.IWFActionRoleAssoc[] = [];

			_.forEach(this.selectedActionIDs, (a) => {
				var assoc = <Models.IWFActionRoleAssoc>{};
				assoc.divisionID = this.selectedProcess.divisionID;
				assoc.processID = this.selectedProcess.processID;
				assoc.roleID = this.selectedRole.roleID;
				assoc.actionID = a;
				associations.push(assoc);
			});

			var request = <Models.IWFActionRoleAssocRequest>{};
			request.associations = associations;
			request.processID = this.selectedProcess.processID;
			request.roleID = this.selectedRole.roleID;

			return this.workflowConfigService.saveActionPermissions(request)
				.then((result) => {
					this.notifyService.broadcastDone();
					form.$setPristine();
					this.notifyService.notifySuccess("Action Permissions saved successfully");
				}).finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

}

export class HierarchyValueSetController {

	static $inject = ["$scope", "$window", "entityConfigService", "notifyService"];

	valueSetID: string;
	initialized: boolean;
	values: Models.ICharacteristicValue[];
	uniqueLabels: string[];
	uniqueValidator: { [key: string]: (value: string) => boolean };
	confirmNewValue: { [key: string]: (value: string) => boolean };
	statusValues: { [key: number]: string };
	editValueID: number;
	editValue: Models.ICharacteristicValue;
	newValueLabel: string;
	newValueDescription: string;
	newValueXref: string;
	newValueStatusID: number;
	showJobProgressStatus: boolean;
	jobId: string;
	jobTitle: string;
	progressStatus: string;

	constructor(private $scope: ng.IScope, private $window: ng.IWindowService, private entityConfigService: EntityConfigService, private notifyService: NotifyService) {
		this.valueSetID = "";
		this.initialized = false;
		this.values = [];
		this.uniqueLabels = [];
		this.statusValues = {
			0: "Inactive",
			1: "Active"
		};
		this.editValueID = -1;
		this.editValue = null;
		this.newValueDescription = "";
		this.newValueLabel = "";
		this.newValueXref = "";
		this.newValueStatusID = 1;
		this.showJobProgressStatus = false;
		this.jobId = "";
		this.jobTitle = "";
		this.progressStatus = "";
		this.uniqueValidator = {};

		$scope.$watch(() => this.editValue,
			(newValue, oldValue) => {
				if (newValue != oldValue) {
					if (newValue != null) {
						this.editValueID = newValue.charValueID;
					} else {
						this.editValueID = null;
					}
				}
			}, true);

		$scope.$watch(() => this.values, (newValue, oldValue) => {
			this.uniqueLabels = newValue.map(v => v.charValueLabel.trim());
		}, true);

		this.uniqueValidator = {
			"uniqueValue": (newValue) => {
				var value = newValue || "";
				var charValue = _.find(this.values, v => v.charValueID != this.editValueID && v.charValueLabel.trim().toLowerCase() == (value || "").trim().toLowerCase());
				return charValue == null;
			}
		};

		this.confirmNewValue = {
			"uniqueValue": (newValue) => {
				var value = newValue || "";
				var charValue = _.find(this.values, v => v.charValueLabel.trim().toLowerCase() === (value || "").trim().toLowerCase());
				return charValue == null;
			}
		};
	}


	Init(valueSetID: string) {
		this.valueSetID = valueSetID;
		this.RefreshList();
	}

	RefreshList() {
		this.notifyService.startProgress();
		return this.entityConfigService.getCharacteristicValueList(this.valueSetID)
			.then((results) => {
				this.values = results;
				this.initialized = true;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Edit(editValue: Models.ICharacteristicValue) {
		this.editValue = _.clone(editValue);
	}

	Save() {
		this.notifyService.startProgress();
		this.entityConfigService.updateCharacteristicValue(this.editValue.charValueID, this.valueSetID, this.editValue.charValueLabel, this.editValue.charValueDescription, this.editValue.xref, this.editValue.statusID)
			.then((result) => {
				this.notifyService.notifySuccess("Value Updated");
				if (!_.isEmpty(result.jobID) && result.jobID != "00000000-0000-0000-0000-000000000000") {
					this.showJobProgressStatus = true;
					this.jobId = result.jobID;
					this.jobTitle = result.jobTitle;
				}
				return this.RefreshList();
			})
			.then(() => {
				this.editValue = null;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Cancel() {
		this.editValue = null;
	}

	Create() {
		this.notifyService.startProgress();
		this.entityConfigService.createCharacteristicValue(this.valueSetID, this.newValueLabel, this.newValueDescription, this.newValueXref, this.newValueStatusID)
			.then((result) => {
				this.notifyService.notifySuccess("Value Created");
				this.newValueLabel = "";
				this.newValueDescription = "";
				this.newValueXref = "";
				this.newValueStatusID = 1;

				return this.RefreshList();
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Delete(editValue: Models.ICharacteristicValue) {

		this.entityConfigService.IsCharValSetCharValUsedInCharValSrcs(editValue.charValueID, this.valueSetID)
			.then((result) => {
				if (result.data) {
					this.$window.alert("You cannot delete this Char Value from this Set because there are one or more Sources associated with this CharValue.");
					this.notifyService.broadcastDone();
				}
				else {
					if (this.$window.confirm("Are you sure?")) {
						this.entityConfigService.deleteCharacteristicValue(editValue.charValueID, this.valueSetID)
							.then(() => {
								this.notifyService.notifySuccess("Value Deleted");
								return this.RefreshList();
							})
							.finally(() => {
								this.notifyService.endProgress();
							});
					} else {
						this.notifyService.broadcastDone();
					}
				}
			});
	}
}

export class ValueSourceGroupController {
	static $inject = ["$scope", "$window", "entityConfigService", "notifyService"];

	charValueSourceID: string;
	charValueSetID: string;
	groups: Models.ICharacteristicValueGroup[];
	initialized: boolean;
	editGroup: Models.ICharacteristicValueGroup;
	editAssocValues: number[];
	editModalOpen: boolean;
	createModalOpen: boolean;
	newCharValueGroupLabel: string;
	newCharValueGroupDescription: string;
	newAssocValues: number[];

	constructor(private $scope: ng.IScope, private $window: ng.IWindowService, private entityConfigService: EntityConfigService, private notifyService: NotifyService) {
		this.charValueSourceID = "";
		this.charValueSetID = "";
		this.initialized = false;
		this.groups = [];
		this.editGroup = null;
		this.editAssocValues = [];
		this.editModalOpen = false;
		this.createModalOpen = false;
		this.newAssocValues = [];
		this.newCharValueGroupDescription = "";
		this.newCharValueGroupLabel = "";

		$scope.$watch(() => this.editModalOpen,
			(newValue, oldValue) => {
				if (!newValue && oldValue) {
					this.editGroup = null;
					this.editAssocValues = [];
				}
			});

		$scope.$watch(() => this.createModalOpen,
			(newValue, oldValue) => {
				if (!newValue && oldValue) {
					this.newAssocValues = [];
					this.newCharValueGroupDescription = "";
					this.newCharValueGroupLabel = "";
				}
			});
	}

	Init(charValueSourceID: string, charValueSetID: string) {
		this.charValueSourceID = charValueSourceID;
		this.charValueSetID = charValueSetID;
		this.RefreshList();
	}

	RefreshList() {
		this.notifyService.startProgress();
		this.entityConfigService.getCharValueGroupList(this.charValueSourceID)
			.then((results) => {
				this.groups = results;
				this.initialized = true;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Edit(group: Models.ICharacteristicValueGroup) {
		this.notifyService.startProgress();
		this.entityConfigService.getCharacteristicValueGroupCharacteristicValueAssociationList(group.charValueGroupID)
			.then((results) => {
				this.editAssocValues = results.map(assoc => assoc.charValueID);
				this.editGroup = _.clone(group);
				this.editModalOpen = true;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	OpenCreate() {
		this.createModalOpen = true;
	}

	Create() {
		this.notifyService.startProgress();
		this.entityConfigService.createCharValueGroup(this.charValueSourceID, this.newCharValueGroupLabel, this.newCharValueGroupDescription, this.newAssocValues)
			.then((result) => {
				this.notifyService.notifySuccess("Characteristic Value Group Created");
				return this.RefreshList();
			}, () => {
				this.notifyService.notifyError("Error Creating Characteristic Value Group");
			})
			.then(() => {
				this.createModalOpen = false;
			}, angular.noop)
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Save() {
		this.notifyService.startProgress();
		this.entityConfigService.updateCharValueGroup(this.editGroup.charValueGroupID, this.editGroup.charValueSourceID, this.editGroup.charValueGroupLabel, this.editGroup.charValueGroupDescription, this.editAssocValues)
			.then(() => {
				this.notifyService.notifySuccess("Value Group Updated");
				return this.RefreshList();
			}, () => {
				this.notifyService.notifyError("Error updating Value Group");
			})
			.then(() => {
				this.editModalOpen = false;
			}, angular.noop)
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Delete(group: Models.ICharacteristicValueGroup) {
		if (this.$window.confirm("Are you sure you want to delete this CharValueGroup?")) {
			this.notifyService.startProgress();
			this.entityConfigService.deleteCharValueGroup(group.charValueGroupID)
				.then(() => {
					this.notifyService.notifySuccess("CharValueGroup Deleted");
					return this.RefreshList();
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
		else {
			this.notifyService.broadcastDone();
		}
	}
}

export class EditTemplateCharacteristicController {

	static $inject = ["$scope", "$q", "$window", "notifyService", "entityConfigService", "reportService", "aclService"];
	charTypeID: number;
	templateID: number;
	templateGroupID: number;
	characteristicID: number;
	isEdit: boolean;
	hasTemplate: boolean;
	yesNoOptions: { [key: number]: string };
	visbilityOptions: { [key: number]: string };
	charValueSets: Models.ICharacteristicValueSet[];
	charValueSources: Models.ICharacteristicValueSource[];
	groups: Models.ITemplateCharacteristicGroup[];
	sortedGroups: Models.ITemplateCharacteristicGroup[];
	dataTypes: {
		key: number;
		value: string;
	}[];
	groupID: number;
	label: string;
	tagLabel: string;
	tagLabelMaxLength: number = 75;
	sequenceNumber: number;
	visInd: number;
	reqInd: number;
	multInd: number;
	editInd: number;
	delInd: number;
	sysInd: number;
	rptInd: number;
	dataType: number;
	maxLength: number;
	valueSetID: string;
	valueSourceID: string;
	oldValueSourceID: string;
	alertEnabled: boolean;
	characteristicUsageIn: Models.ICharacteristicUsageIn[];
	lockCharValueSet: boolean;
	charTypeCharacteristicHasData: boolean;
	hasAdHocReports: boolean = false;
	warningInd: number;
	isAdmin = false;
	reqIndOptions: { [key: number]: string };
	permissions: _.Dictionary<Models.IAspNetSecurityPolicyPermission>;
	description: string;

	//Conditional Fields
	conditionalField: Models.IConditionalField;
	triggerFields: Models.ICharacteristicMetaData[] = [];
	//--

	get showValueSets() {
		return (this.dataType == 3 || this.dataType == 13 || this.dataType == 14) && this.hasTemplate && !this.isEdit;
	}

	get showValueSources() {
		return this.valueSetID && (this.dataType == 3 || this.dataType == 13 || this.dataType == 14);
	}

	get showAlerts() {
		return this.dataType == 5;
	}

	constructor(
		private $scope: ng.IScope,
		private $q: ng.IQService,
		private $window: ng.IWindowService,
		private notifyService: NotifyService,
		private entityConfigService: EntityConfigService,
		private reportService: ReportService,
		private aclService: AclService
	) {

		this.yesNoOptions = {
			0: "No",
			1: "Yes"
		};

		this.visbilityOptions = {
			0: "Hidden",
			1: "Internal Only",
			2: "Both Internal & External"
		};
		this.charValueSets = [];
		this.dataTypes = [];
		this.charValueSources = [];
		this.groups = [];
		this.characteristicID = 0;
		this.label = "";
		this.tagLabel = "";
		this.sequenceNumber = 0;
		this.visInd = 2;
		this.reqInd = 0;
		this.multInd = 0;
		this.editInd = 0;
		this.delInd = 0;
		this.sysInd = 0;
		this.rptInd = 1;
		this.dataType = 3;
		this.maxLength = 10000;
		this.valueSetID = "";
		this.valueSourceID = "";
		this.oldValueSourceID = "";
		this.alertEnabled = false;
		this.characteristicUsageIn = [];
		this.lockCharValueSet = false;
		this.charTypeCharacteristicHasData = false;
		this.reqIndOptions = {
			0: "No",
			1: "Required",
			2: "Desired"
		};
		this.description = "";

		// auto sort groups by sequenceNumber
		$scope.$watch(() => this.groups, (newValue, oldValue) => {
			this.sortedGroups = _.sortBy(newValue, g => g.sequenceNumber);
		}, true);

		// auto format label-> tagLabel  while not in edit mode
		$scope.$watch(() => this.label, (newValue, oldValue) => {
			if (newValue != oldValue && !this.isEdit) {
				var value = newValue || "";
				value = value.toLowerCase().trim();
				value = value.replace(/\s+/g, "_");
				value = value.replace(/[^a-z_0-9]/g, "");
				this.tagLabel = value;
			}
		}, true);

		// reset valueSetID when datatype goes from 3 -> anything
		$scope.$watch(() => this.dataType, (newValue, oldValue) => {
			if ((oldValue == Consts.CharDataTypeIDs.CharDataTypes.alphanumeric || oldValue == Consts.CharDataTypeIDs.CharDataTypes.checkbox || oldValue == Consts.CharDataTypeIDs.CharDataTypes.money) && (newValue != Consts.CharDataTypeIDs.CharDataTypes.alphanumeric && newValue != Consts.CharDataTypeIDs.CharDataTypes.checkbox && newValue != Consts.CharDataTypeIDs.CharDataTypes.money)) {
				this.valueSetID = null;
			}
		});

		// reload the Value Source List whenever the Value Set changes
		$scope.$watch(() => this.valueSetID, (newValue, oldValue) => {
			if (newValue != oldValue && !_.isEmpty(newValue)) {
				this.LoadValueSource(newValue)
					.then(() => {

						if (this.charValueSources.length == 0) {
							alert("You can not select a CharValueSet that has no CharValueSources defined.");
							this.valueSetID = oldValue;
						}

						if (!_.any(this.charValueSources, cvs => cvs.charValueSourceID == this.valueSourceID)) {
							this.valueSourceID = null;
						}
					});

			} else {
				this.valueSourceID = null;
			}
		}, true);

		$scope.$watch(() => this.valueSourceID, (newValue, oldValue) => {
			if (oldValue != null) {
				if (newValue != this.oldValueSourceID) {
					if (!this.$window.confirm("Changing a Value Source will result in invalid data for existing templates, Are you sure you want to continue?")) {
						this.oldValueSourceID = oldValue;
						this.valueSourceID = oldValue;
					}
					else {
						this.oldValueSourceID = newValue;
					}
				}
			}
		});

		this.$scope.$on(Consts.Events.DeleteConditionalField,
			() => {
				this.notifyService.startProgress();

				this.entityConfigService.deleteConditionalField(this.conditionalField)
					.then(() => {
						//Setup the base conditional field
						this.conditionalField = {
							charID: this.characteristicID,
							charTypeID: this.charTypeID,
							conditionalFieldID: null,
							conditionalFieldTypeID: null,
							divID: 0,
							templateID: this.templateID,
							triggerCharID: 0,
							triggerGroupID: null,
							triggerValue: ""
						};

						this.notifyService.endProgress();
					})
					.finally(() => {
						this.notifyService.notifySuccess("Conditional Field deleted");
					})
			});

		this.aclService.loadAcls()
			.then((acls) => {
				this.isAdmin = Utils.AclUtil.hasReadAccess(acls, Consts.Acl.Activities.Admin);
			});

	}

	LoadTemplateCharacteristic() {
		this.notifyService.startProgress();

		if (this.charTypeID > 0 && this.templateID > 0) {
			return this.entityConfigService.getCharacteristicTemplateMetaDataCollection(this.charTypeID, this.templateID)
				.then((results) => {

					//Conditional Fields
					this.triggerFields = [];

					let triggerFieldCMDs = _.cloneDeep(results);

					//Remove the current field
					let currentField = _.first(_.filter(triggerFieldCMDs, c => c.characteristicID == this.characteristicID));
					let index = _.indexOf(triggerFieldCMDs, currentField);
					triggerFieldCMDs.splice(index, 1);
					//--

					//Remove all fields that are not LOV
					let onlyLOVs = _.filter(triggerFieldCMDs, c => c.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.alphanumeric
						&& !_.isNull(c.charValueSetID)
						&& !_.isNull(c.charValueSourceID));
					//--

					let loopingChars: Models.ICharacteristicMetaData[] = this.findLoopingChars(onlyLOVs, this.characteristicID);
					let nonCircularChars = _.difference(onlyLOVs, loopingChars);

					//Set the variable to pass to the directive
					let sorted = _.sortBy(nonCircularChars, f => f.label);
					this.triggerFields = sorted;

					let cmd = <Models.ICharacteristicMetaDataLegacyIndicators>_.find(results, cmd2 => cmd2.characteristicID == this.characteristicID);
					if (cmd != null) {
						this.groupID = cmd.groupID;
						this.label = cmd.label;
						this.tagLabel = cmd.tagLabel;
						this.sequenceNumber = cmd.sequenceNumber;
						this.visInd = cmd.visibilityIndicator;
						this.reqInd = cmd.requiredIndicator;
						this.multInd = cmd.multipleIndicator;
						this.editInd = cmd.editIndicator;
						this.delInd = cmd.deleteIndicator;
						this.sysInd = cmd.systemIndicator;
						this.dataType = cmd.dataTypeID;
						this.maxLength = cmd.maxLength;
						this.valueSetID = cmd.charValueSetID;
						this.valueSourceID = cmd.charValueSourceID;
						this.description = cmd.description;
					}
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	private findLoopingChars(allCharDatas: Models.ICharacteristicMetaData[], currentCharacteristicId: number, visitedChars: Models.ICharacteristicMetaData[] = []) {
		let alreadyVisited = _.any(visitedChars, x => x.triggerCharID == currentCharacteristicId);
		let triggers = allCharDatas.filter(x => !alreadyVisited && x.triggerCharID == currentCharacteristicId);

		for (let trigger of triggers) {
			visitedChars.push(trigger);
		}

		for (let trigger of triggers) {
			this.findLoopingChars(allCharDatas, trigger.characteristicID, visitedChars);
		}

		return visitedChars;
	}

	LoadCharacteristic() {
		this.notifyService.startProgress();

		if (this.charTypeID > 0 && this.characteristicID > 0) {
			return this.entityConfigService.getCharacteristic(this.charTypeID, this.characteristicID)
				.then((result) => {
					if (result != null) {
						this.label = result.label;
						this.tagLabel = result.tagLabel;
						this.multInd = result.multipleIndicator;
						this.sysInd = result.systemIndicator;
						this.dataType = result.dataTypeID;
						this.maxLength = result.maxLength;
						this.valueSetID = result.charValueSetID;
						this.rptInd = result.reportIndicator;
						this.description = result.description;

						this.entityConfigService.getCharacteristicUsageIn(this.charTypeID, this.characteristicID)
							.then((result) => {
								this.characteristicUsageIn = result;
								if (this.characteristicUsageIn.length > 0) {
									_.forEach(result, (charUsageIn) => {
										this.entityConfigService.getCharacteristicTemplateMetaDataCollection(this.charTypeID, charUsageIn.templateID)
											.then((cmdResult) => {
												var cmd = _.find(cmdResult, cmd2 => cmd2.characteristicID == this.characteristicID);
												if (cmd != null && cmd.charValueSourceID != null) {
													this.lockCharValueSet = true;
												}
											})
									});
								}
								else {
									this.lockCharValueSet = false;
								}
							});
					}
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	LoadValues() {
		this.notifyService.startProgress();
		var promise1 = this.entityConfigService.getCharacteristicValueSetList()
			.then((results) => {
				this.charValueSets = results;
			});

		var promise2 = this.entityConfigService.getCharDataTypes()
			.then((results) => {
				this.dataTypes = results;
			});


		var promises = [promise1, promise2];

		if (this.templateID != null && this.templateID > 0) {
			var promise3 = this.entityConfigService.getCharacteristicGroupList(this.charTypeID)
				.then((results) => {
					this.groups = results;
				});

			promises.push(promise3);
			var promise4 = this.entityConfigService.getCharacteristicTemplate(this.charTypeID, this.templateID)
				.then((result) => {
					this.templateGroupID = result.template.templateGroupID;
				});


			promises.push(promise4);
		}

		return this.$q.all(promises)
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadValueSource(valueSetID: string) {
		this.notifyService.startProgress();
		return this.entityConfigService.getCharacteristicValueSourceList(valueSetID)
			.then((results) => {
				this.charValueSources = results;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	InitTemplateCreate(charTypeID: number, templateID: number, groupID: number) {
		this.charTypeID = charTypeID;
		this.templateID = templateID;
		this.groupID = groupID;
		this.editInd = 1;
		this.delInd = 1;

		this.hasTemplate = true;
		this.isEdit = false;

		//Setup the base conditional field
		this.conditionalField = {
			charID: this.characteristicID,
			charTypeID: this.charTypeID,
			conditionalFieldID: null,
			conditionalFieldTypeID: null,
			divID: 0,
			templateID: this.templateID,
			triggerCharID: 0,
			triggerGroupID: null,
			triggerValue: ""
		};

		//Get the current Conditional Field data if applicable
		var conditionalFieldsPromise = this.entityConfigService.getConditionalField(this.charTypeID, this.templateID, this.characteristicID)
			.then((result) => {
				if (result.data) {
					this.conditionalField = result.data;
				}
			});

		var conditionalFieldTriggerPromise = this.entityConfigService.getCharacteristicTemplateMetaDataCollection(this.charTypeID, this.templateID)
			.then((results) => {

				//Conditional Fields
				this.triggerFields = [];

				var triggerFieldCMDs = _.cloneDeep(results);

				//Remove the current field
				var currentField = _.first(_.filter(triggerFieldCMDs, c => c.characteristicID == this.characteristicID));
				var index = _.indexOf(triggerFieldCMDs, currentField);
				triggerFieldCMDs.splice(index, 1);
				//--

				//Remove all fields that are not LOV
				var onlyLOVs = _.filter(triggerFieldCMDs, c => c.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.alphanumeric && !_.isNull(c.charValueSetID)
					&& !_.isNull(c.charValueSourceID));
				//--

				//Set the variable to pass to the directive
				var sorted = _.sortBy(onlyLOVs, f => f.label);
				this.triggerFields = sorted;
			});

		this.notifyService.startProgress();
		this.$q.all([this.LoadValues(), conditionalFieldTriggerPromise])
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	InitTemplateEdit(charTypeID: number, templateID: number, characteristicID: number) {
		this.charTypeID = charTypeID;
		this.templateID = templateID;
		this.characteristicID = characteristicID;
		this.hasTemplate = true;
		this.isEdit = true;

		//Setup the base conditional field
		this.conditionalField = {
			charID: this.characteristicID,
			charTypeID: this.charTypeID,
			conditionalFieldID: null,
			conditionalFieldTypeID: null,
			divID: 0,
			templateID: this.templateID,
			triggerCharID: 0,
			triggerGroupID: null,
			triggerValue: ""
		};

		//Get the current Conditional Field data if applicable
		var conditionalFieldsPromise = this.entityConfigService.getConditionalField(this.charTypeID, this.templateID, this.characteristicID)
			.then((result) => {
				if (result.data) {
					this.conditionalField = result.data;
				}
			});

		this.notifyService.startProgress();
		this.$q.all([this.LoadValues(), this.LoadTemplateCharacteristic(), conditionalFieldsPromise])
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	InitCharEdit(charTypeID: number, characteristicID: number) {
		this.charTypeID = charTypeID;
		this.characteristicID = characteristicID;

		this.hasTemplate = false;
		this.isEdit = true;

		this.notifyService.startProgress();
		this.$q.all([this.LoadValues(), this.LoadCharacteristic(), this.GetCharacteristicDataCount(), this.GetAdHocReportingStatus()])
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	InitCharCreate(charTypeID: number) {
		this.charTypeID = charTypeID;
		this.hasTemplate = false;
		this.isEdit = false;

		this.notifyService.startProgress();
		this.$q.all([this.LoadValues()])
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Save(isValid: boolean) {
		if (isValid) {
			if (!this.isEdit && this.hasTemplate) {
				this.CreateTemplateChar();
			} else if (this.isEdit && this.hasTemplate) {
				this.EditTemplateChar();
			} else if (!this.isEdit && !this.hasTemplate) {
				this.CreateCharacteristic();
			} else if (this.isEdit && !this.hasTemplate) {
				this.EditCharacteristic();
			}
		}
	}

	CreateTemplateChar() {
		var cmd: Models.ICharacteristicMetaDataLegacyIndicators = {
			characteristicID: 0,
			charTypeID: this.charTypeID,
			dataTypeID: this.dataType,
			charValueSetID: this.valueSetID,
			charValueSourceID: this.valueSourceID,
			deleteIndicator: this.delInd,
			editIndicator: this.editInd,
			groupID: this.groupID,
			label: this.label,
			maxLength: this.maxLength,
			multipleIndicator: this.multInd,
			requiredIndicator: this.reqInd,
			sequenceNumber: this.sequenceNumber,
			systemIndicator: this.sysInd,
			reportIndicator: this.rptInd,
			tagLabel: this.tagLabel,
			acl: null,
			visibilityIndicator: this.visInd,
			description: this.description,
			triggerCharID: null,
			triggerTypeID: null,
			triggerValue: null
		};
		this.notifyService.startProgress();
		this.entityConfigService.addAndAssociateCharacteristic(this.charTypeID, this.templateID, this.groupID, cmd, this.permissions, this.conditionalField)
			.then((result) => {
				if (result.success) {
					this.notifyService.notifySuccess("Characteristic Created");
					this.$window.location.assign(Utils.UrlBuilder.configurationTemplateTemplateMetaDataUrl(this.charTypeID, this.templateID));
				} else {
					this.notifyService.notifyError(result.message);
				}
			})
			.finally(() => {

				this.notifyService.endProgress();
			});
	}

	EditTemplateChar() {
		var cmd: Models.ICharacteristicMetaDataLegacyIndicators = {
			characteristicID: this.characteristicID,
			charTypeID: this.charTypeID,
			dataTypeID: this.dataType,
			charValueSetID: this.valueSetID,
			charValueSourceID: this.valueSourceID,
			deleteIndicator: this.delInd,
			editIndicator: this.editInd,
			groupID: this.groupID,
			label: this.label,
			maxLength: this.maxLength,
			multipleIndicator: this.multInd,
			requiredIndicator: this.reqInd,
			sequenceNumber: this.sequenceNumber,
			systemIndicator: this.sysInd,
			reportIndicator: this.rptInd,
			tagLabel: this.tagLabel,
			acl: null,
			visibilityIndicator: this.visInd,
			description: this.description,
			triggerTypeID: null,
			triggerCharID: null,
			triggerValue: null
		};
		this.notifyService.startProgress();
		this.entityConfigService.addAndAssociateCharacteristic(this.charTypeID, this.templateID, this.groupID, cmd, this.permissions, this.conditionalField)
			.then((result) => {
				if (result.success) {
					this.notifyService.notifySuccess("Characteristic Updated");
					this.$window.location.assign(Utils.UrlBuilder.configurationTemplateTemplateMetaDataUrl(this.charTypeID, this.templateID));
				} else {
					this.notifyService.notifyError(result.message);
				}
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	CreateCharacteristic() {
		this.notifyService.startProgress();
		this.entityConfigService.createCharacteristic(this.charTypeID, this.label, this.tagLabel, this.sysInd, this.multInd, this.valueSetID, this.dataType, this.maxLength, this.rptInd, this.description)
			.then((result) => {
				if (result.success) {
					this.notifyService.notifySuccess("Characteristic Created");
					this.$window.location.assign(Utils.UrlBuilder.configurationCharacteristicsUrl(this.charTypeID));
				} else {
					this.notifyService.notifyError(result.message);
				}
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	EditCharacteristic() {
		this.notifyService.startProgress();
		this.entityConfigService.updateCharacteristic(this.charTypeID, this.characteristicID, this.label, this.tagLabel, this.sysInd, this.multInd, this.valueSetID, this.dataType, this.maxLength, this.rptInd, this.description)
			.then((result) => {
				if (result.success) {
					this.notifyService.notifySuccess("Characteristic Updated");
					this.$window.location.assign(Utils.UrlBuilder.configurationCharacteristicsUrl(this.charTypeID));
				} else {
					this.notifyService.notifyError(result.message);
				}
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	GetAdHocReportingStatus() {
		return this.reportService.isCharacteristicOnAdHocReport(this.charTypeID, this.characteristicID)
			.then((result: Models.IDataResponse<boolean>) => {
				if (result.success) {
					this.hasAdHocReports = result.data;
				}
				else {
					this.notifyService.notifyError(result.message);
				}
			});
	}

	GetCharacteristicDataCount() {
		return this.entityConfigService.getCharacteristicDataCount(this.charTypeID, this.characteristicID)
			.then((result) => {
				if (result.success) {
					if (result.data > 0) {
						this.charTypeCharacteristicHasData = true;;
					}
					else {
						this.charTypeCharacteristicHasData = false;
					}
				}
				else {
					this.charTypeCharacteristicHasData = false;
				}
			});
	}
}

export class PolicyListController {

	static $inject = ["$scope", "$window", "$q", "notifyService", "securityConfigService", "aclService"];

	policies: Models.IAspNetSecurityPolicy[];
	policyModalCreateOpen: boolean;
	policyTypeID: number;
	policyID: string;

	policyTypes: { [key: number]: string };
	policyTitle: string;
	policyDivGlobal: boolean;

	policyModalEditOpen: boolean;

	isAdmin: boolean;

	constructor(private $scope: ng.IScope, private $window: ng.IWindowService, private $q: ng.IQService, private notifyService: NotifyService, private securityConfigService: SecurityConfigService, private aclService: AclService) {

		this.policies = [];
		this.policyModalCreateOpen = false;
		this.policyTypeID = null;
		this.policyTitle = "";
		this.policyID = "";
		this.policyDivGlobal = false;
		this.isAdmin = false;


		this.policyTypes = {
			0: "Activity Policy",
			1: "Data Policy",
			//2: "Workflow Policy"
		};

		this.Init();

		$scope.$watch(() => this.policyModalCreateOpen, (newValue, oldValue) => {
			if (oldValue && !newValue) {
				this.policyID = "";
				this.policyTitle = "";
				this.policyTypeID = null;
				this.policyDivGlobal = false;
			}
		});

		$scope.$watch(() => this.policyModalEditOpen, (newValue, oldValue) => {
			if (oldValue && !newValue) {
				this.policyID = "";
				this.policyTitle = "";
				this.policyTypeID = null;
				this.policyDivGlobal = false;
			}
		});
	}

	Init() {
		var promise1 = this.RefreshList();
		var promise2 = this.aclService.loadAcls()
			.then((acls) => {
				this.isAdmin = Utils.AclUtil.hasReadAccess(acls, Consts.Acl.Activities.Admin);
			});

		return this.$q.all([promise1, promise2]);
	}

	RefreshList() {
		this.notifyService.startProgress();
		return this.securityConfigService.getSecurityPolicyList()
			.then((result) => {
				this.policies = result;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	CreatePolicy(policyType: number, $event: ng.IAngularEvent) {
		$event.preventDefault();
		this.policyTypeID = policyType;
		this.policyModalCreateOpen = true;
	}

	Create() {
		this.notifyService.startProgress();
		this.securityConfigService.createSecurityPolicy(this.policyTitle, this.policyTypeID, this.policyDivGlobal)
			.then((result) => {
				this.notifyService.notifySuccess("Policy Created");
				return this.RefreshList()
					.then(() => {
						this.policyModalCreateOpen = false;
					});
			},
				() => {
					this.notifyService.notifyError("Error Creating Policy");
				})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Edit(policy: Models.IAspNetSecurityPolicy) {
		this.policyTitle = policy.policyTitle;
		this.policyTypeID = policy.policyType;
		this.policyDivGlobal = policy.isGlobal;
		this.policyID = policy.securityPolicyID;
		this.policyModalEditOpen = true;
	}

	Update(isValid: boolean) {
		if (isValid) {
			this.notifyService.startProgress();
			this.securityConfigService.updateSecurityPolicy(this.policyID, this.policyTitle, this.policyTypeID, this.policyDivGlobal)
				.then(() => {
					this.notifyService.notifySuccess("Policy Updated");
					return this.RefreshList()
						.then(() => {
							this.policyModalEditOpen = false;
						});
				}, this.notifyService.errorResponseHandler)
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	DeletePolicy(policy: Models.IAspNetSecurityPolicy) {
		if (this.$window.confirm("Are you sure you want to Delete this policy?")) {
			this.notifyService.startProgress();
			this.securityConfigService.deleteSecurityPolicy(policy.securityPolicyID)
				.then(() => {
					this.notifyService.notifySuccess("Policy Deleted");
					return this.RefreshList();
				},
					(reason: ng.IHttpPromiseCallbackArg<any>) => {
						this.notifyService.notifyError("Error Deleting Policy: " + reason.statusText);
					})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.notifyService.broadcastDone();
		}
	}

}



export class EditPolicyActivitiesController {
	static $inject = ["$scope", "$q", "$window", "securityConfigService", "notifyService"];

	activityNodes: Models.IAspNetSecurityActivity[];
	pathSummary: string;
	depth: number;

	createModalOpen: boolean;
	createParentSecurityActivityID: string;
	createTitle: string;
	createDescription: string;
	createKey: string;

	editModalOpen: boolean;
	editActivity: Models.IAspNetSecurityActivity;

	constructor(private $scope: ng.IScope, private $q: ng.IQService, private $window: ng.IWindowService, private securityConfigService: SecurityConfigService, private notifyService: NotifyService) {

		this.activityNodes = [];
		this.pathSummary = "";
		this.depth = 0;

		this.createModalOpen = false;
		this.createParentSecurityActivityID = "";
		this.createTitle = "";
		this.createDescription = "";
		this.createKey = "";

		this.editModalOpen = false;
		this.editActivity = null;


		$scope.$watch(() => this.createModalOpen,
			(newValue, oldValue) => {
				if (!newValue && oldValue) {
					this.createParentSecurityActivityID = "";
					this.createTitle = "";
					this.createDescription = "";
					this.createKey = "";
				}
			});

		$scope.$watch(() => this.editModalOpen,
			(newValue, oldValue) => {
				if (!newValue && oldValue) {
					this.editActivity = null;
				}
			});

		var walkPaths = (activityNodes: Models.IAspNetSecurityActivity[], path: string) => {

			activityNodes.forEach((activity) => {

				var nPath = path + "/" + activity.activityKey;
				this.pathSummary += nPath + "\n";

				walkPaths(activity.childActivities, nPath);
			});

		};

		$scope.$watch(() => this.activityNodes,
			(newValue, oldValue) => {
				this.pathSummary = "";
				walkPaths(this.activityNodes, "");
			}, true);


		this.RefreshList();
	}


	RefreshList() {
		this.notifyService.startProgress();

		return this.securityConfigService.getSecurityActivityTree()
			.then((result) => {
				this.activityNodes = result
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	OpenCreateActivity(parentActivity: Models.IAspNetSecurityActivity) {
		if (parentActivity != null) {
			this.createParentSecurityActivityID = parentActivity.securityActivityID;
		} else {
			this.createParentSecurityActivityID = null;
		}
		this.createModalOpen = true;
	}

	CreateActivity() {
		this.notifyService.startProgress();

		this.securityConfigService.createSecurityActivity(this.createParentSecurityActivityID, this.createTitle, this.createDescription, this.createKey)
			.then(() => {
				this.notifyService.notifySuccess("Activity Created");
				return this.RefreshList();
			}, this.notifyService.errorResponseHandler)
			.then(() => { this.createModalOpen = false; }, angular.noop)
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	OpenEditActivity(activity: Models.IAspNetSecurityActivity) {
		this.editActivity = _.clone(activity);
		this.editModalOpen = true;
	}

	UpdateActivity() {
		this.notifyService.startProgress();

		var activity = this.editActivity;
		this.securityConfigService.updateSecurityActivity(activity.securityActivityID, activity.parentSecurityActivityID, activity.activityTitle, activity.activityDescription, activity.activityKey)
			.then(() => {
				this.notifyService.notifySuccess("Activity Updated");
				return this.RefreshList();
			},
				this.notifyService.errorResponseHandler)
			.then(() => { this.editModalOpen = false; }, angular.noop)
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	DeleteActivity(activity: Models.IAspNetSecurityActivity) {

		var count = 0;
		_.foreachGraph(activity.childActivities, a => a.childActivities, (a) => {
			count++;
		});

		var message = "Are you sure you want to delete this?";
		if (count > 0) {
			message = "Are you sure you want to delete this and " + count + " descendant(s)?";
		}

		if (this.$window.confirm(message)) {

			this.notifyService.startProgress();
			this.securityConfigService.deleteSecurityActivity(activity.securityActivityID)
				.then(() => {
					this.notifyService.notifySuccess("Activity Deleted");
					return this.RefreshList();
				},
					this.notifyService.errorResponseHandler)
				.finally(() => {
					this.notifyService.endProgress();
				});

		} else {
			this.notifyService.broadcastDone();
		}
	}

}

export class IdentityRoleConfigController {
	static $inject = ["$scope", "$q", "$window", "notifyService", "identityService", "securityConfigService"];

	roles: Models.IAspNetUserRole[];
	activityPolicies: Models.IAspNetSecurityPolicy[];
	dataPolicies: Models.IAspNetSecurityPolicy[];
	workflowPolicies: Models.IAspNetSecurityPolicy[];
	adminPolicies: Models.IAspNetSecurityPolicy[];

	roleModalOpen: boolean;

	editRoleID: string;
	editRoleText: string;
	editRoleXref: string;
	editRoleActivitySecurityPolicyID: string;
	editRoleDataSecurityPolicyID: string;
	editRoleWorkflowSecurityPolicyID: string;
	editRoleAdminActivitySecurityPolicyID: string;

	constructor(private $scope: ng.IScope, private $q: ng.IQService, private $window: ng.IWindowService, private notifyService: NotifyService, private identityService: IdentityService, private securityConfigService: SecurityConfigService) {
		this.roles = [];
		this.activityPolicies = [];
		this.dataPolicies = [];
		this.workflowPolicies = [];
		this.adminPolicies = [];

		this.roleModalOpen = false;

		this.editRoleID = "";
		this.editRoleText = "";
		this.editRoleXref = null;
		this.editRoleActivitySecurityPolicyID = "";
		this.editRoleAdminActivitySecurityPolicyID = "";
		this.editRoleWorkflowSecurityPolicyID = "";
		this.editRoleDataSecurityPolicyID = "";

		$scope.$watch(() => this.roleModalOpen,
			(newValue, oldValue) => {
				if (!newValue && oldValue) {
					//resets
					this.editRoleID = "";
					this.editRoleText = "";
					this.editRoleXref = null;
					this.editRoleActivitySecurityPolicyID = "";
					this.editRoleAdminActivitySecurityPolicyID = "";
					this.editRoleWorkflowSecurityPolicyID = "";
					this.editRoleDataSecurityPolicyID = "";
				}
			});
	}

	Init() {
		this.notifyService.startProgress();

		var promise1 = this.RefreshList();

		var promise2 = this.securityConfigService.getSecurityPolicyList()
			.then((results) => {
				var localPolicies = results.filter(p => !p.isGlobal);

				this.activityPolicies = localPolicies.filter(p => p.policyType == Consts.SecurityPolicyType.Activity);
				this.dataPolicies = localPolicies.filter(p => p.policyType == Consts.SecurityPolicyType.Data);
				this.workflowPolicies = localPolicies.filter(p => p.policyType == Consts.SecurityPolicyType.Workflow);
				this.adminPolicies = localPolicies.filter(p => p.policyType == Consts.SecurityPolicyType.Admin);
			});

		this.$q.when([promise1, promise2])
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	RefreshList() {
		this.notifyService.startProgress();
		this.identityService.getRoleList()
			.then((results) => {
				this.roles = results;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	Create() {
		this.roleModalOpen = true;
	}

	Edit(role: Models.IAspNetUserRole) {
		this.editRoleID = role.roleID;
		this.editRoleActivitySecurityPolicyID = role.activitySecurityPolicyID;
		this.editRoleAdminActivitySecurityPolicyID = role.adminActivitySecurityPolicyID;
		this.editRoleDataSecurityPolicyID = role.dataSecurityPolicyID;
		this.editRoleWorkflowSecurityPolicyID = role.workflowSecurityPolicyID;
		this.editRoleText = role.name;
		this.editRoleXref = role.xref;

		this.roleModalOpen = true;
	}

	Delete(role: Models.IAspNetUserRole) {
		if (this.$window.confirm("Are you sure?")) {
			this.notifyService.startProgress();
			this.identityService.deleteRole(role.roleID)
				.then(() => {
					this.notifyService.notifySuccess("Role Deleted");
					return this.RefreshList();
				}, this.notifyService.errorResponseHandler)
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.notifyService.broadcastDone();
		}
	}

	Save(valid: boolean) {
		if (valid) {
			if (_.isEmpty(this.editRoleID)) {
				// create
				this.notifyService.startProgress();
				this.identityService.createRole(this.editRoleText, this.editRoleXref, this.editRoleActivitySecurityPolicyID, this.editRoleDataSecurityPolicyID, this.editRoleWorkflowSecurityPolicyID, this.editRoleAdminActivitySecurityPolicyID)
					.then(() => {
						this.notifyService.notifySuccess("Role Created");
						return this.RefreshList();
					}, this.notifyService.errorResponseHandler)
					.finally(() => {
						this.notifyService.endProgress();
						this.roleModalOpen = false;
					});
			} else {
				// update
				this.notifyService.startProgress();
				this.identityService.updateRole(this.editRoleID, this.editRoleText, this.editRoleXref, this.editRoleActivitySecurityPolicyID, this.editRoleDataSecurityPolicyID, this.editRoleWorkflowSecurityPolicyID, this.editRoleAdminActivitySecurityPolicyID)
					.then(() => {
						this.notifyService.notifySuccess("Role Updated");
						return this.RefreshList();
					}, this.notifyService.errorResponseHandler)
					.finally(() => {
						this.notifyService.endProgress();
						this.roleModalOpen = false;
					});
			}
		}
	}
}
